enum SystemLevel  {
    SuperAdmin = 1,
    Management = 2,
    FocalPoint = 3,
    GateKeeper = 4,
    Viewer = 5
}

export default SystemLevel